/**
 * @author Ariel
 * @createDate 2020-7-10
 * @description 岗位能力评估雷达图demo
 */
import React from "react";
import {connect} from "dva";
import {framework_tool, component_tool} from '../../../tool'
import {PositionRadar} from '../../../components'

let {WizCard} = component_tool
let {WizContainer} = framework_tool

class PositionRadarDemo extends WizContainer {
  componentName = 'positionRadar';

  _render() {
    return (
      <WizCard title="销售顾问2星能力评估">
        <PositionRadar
          radarProps={{
            data: [
              {item: '品牌', a: 100, b: 20, c: 18.46},
              {item: '产品', a: 100, b: 20, c: 18.29},
              {item: '流程', a: 100, b: 20, c: 16.92},
              {item: '客户管理', a: 100, b: 20, c: 15.38},
              {item: '销售技巧', a: 100, b: 20, c: 20.00},
              {item: '礼仪仪表与沟通', a: 100, b: 20, c: 12.31}
            ],
            dataFormat: {
              type: 'fold',
              fields: ['a', 'b', 'c'],
              key: 'user',
              value: 'score',
            },
            cols: {
              score: {
                min: 0,
                max: 100,
                tickInterval: 10 //用于指定坐标轴各个标度点的间距，是原始数据之间的间距差值
              },
              user: {formatter: val => ({a: '7星能力值满分', b: '2星目标能力值', c: '2星实际能力值'}[val])},
            }
          }}
        />
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(PositionRadarDemo);
